import React from 'react';
import {useTranslation} from 'react-i18next';
import './LanguageSwitcher.css';

export const LanguageSwitcher: React.FC = () => {
    const {i18n} = useTranslation();
    const currentLanguage = i18n.language;

    // Get language URLs from environment variables if they exist
    const getLanguageUrl = (lang: string): string | null => {
        const envKey = `REACT_APP_LANGUAGE_URL_${lang.toUpperCase()}`;
        return process.env[envKey] || null;
    };

    // Get external URLs for languages
    const ruExternalUrl = getLanguageUrl('ru');
    const enExternalUrl = getLanguageUrl('en');
    // Function to change language locally (when no external URL is provided)
    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    // Always show both languages, even if one is fixed
    const showRussian = true;
    const showEnglish = true;

    return (
        <div className="LanguageSwitcher">
            {showRussian && (
                ruExternalUrl ? (
                    // Use <a> tag if external URL is provided
                    <a
                        href={ruExternalUrl}
                        className={`LanguageSwitcher-button ${currentLanguage === 'ru' ? 'active' : ''}`}
                    >
                        RU
                    </a>
                ) : (
                    // Use button with onClick handler if no external URL
                    <button
                        className={`LanguageSwitcher-button ${currentLanguage === 'ru' ? 'active' : ''}`}
                        onClick={() => changeLanguage('ru')}
                    >
                        RU
                    </button>
                )
            )}
            {showEnglish && (
                enExternalUrl ? (
                    // Use <a> tag if external URL is provided
                    <a
                        href={enExternalUrl}
                        className={`LanguageSwitcher-button ${currentLanguage === 'en' ? 'active' : ''}`}
                    >
                        EN
                    </a>
                ) : (
                    // Use button with onClick handler if no external URL
                    <button
                        className={`LanguageSwitcher-button ${currentLanguage === 'en' ? 'active' : ''}`}
                        onClick={() => changeLanguage('en')}
                    >
                        EN
                    </button>
                )
            )}
        </div>
    );
};

export default LanguageSwitcher;
